<template>
  <BaseCard class="campaign-card">
    <a class="campaign-card__campaign-link" :href="href" target="_blank">
      <CampaignCardHeader
        class="campaign-link__campaign-card-header"
        :status="campaign.status"
        :main-visual="campaign['main_visual']['file']"
        :remaining-days="remainingDays"
        :user="campaign.user"
      />
      <CampaignCardBody
        class="campaign-link__campaign-card-body"
        :title="campaign.title"
        :associate="campaign.associate"
        :current-value="currentValue"
        :is-target-donor="isTargetDonor"
        :goal="targetValue"
        :extra-goal1="targetValueStretch1"
        :extra-goal2="targetValueStretch2"
      />
    </a>
  </BaseCard>
</template>

<script>
import BaseCard from '@/components/BaseCard';
import CampaignCardHeader from '@/components/CampaignCardHeader';
import CampaignCardBody from '@/components/CampaignCardBody';
import {
  calculateRemainingDays,
  getCurrentValue,
  getTargetValue,
  getTargetValueStretch1,
  getTargetValueStretch2,
  isTargetDonor,
} from '@/campaign-helper';

export default {
  name: 'CampaignCard',
  components: {
    BaseCard,
    CampaignCardHeader,
    CampaignCardBody,
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    href() {
      // 本番・ローカルで出し分ける必要があるが、後回し
      return `https://syncable.biz/campaign/${this.campaign['id']}/`;
    },
    remainingDays() {
      return calculateRemainingDays(this.campaign);
    },
    currentValue() {
      return getCurrentValue(this.campaign);
    },
    isTargetDonor() {
      return isTargetDonor(this.campaign);
    },
    targetValue() {
      return getTargetValue(this.campaign);
    },
    targetValueStretch1() {
      return getTargetValueStretch1(this.campaign);
    },
    targetValueStretch2() {
      return getTargetValueStretch2(this.campaign);
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-card__campaign-link {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  color: inherit;
  text-decoration: none;
}

.campaign-link__campaign-card-header {
  flex-grow: 0;
}

.campaign-link__campaign-card-body {
  flex-grow: 1;
}
</style>
